import { useState, useEffect, useCallback } from 'react';
import log from '@atlassian/jira-common-util-logging/src/log';
import { fetchJson } from '@atlassian/jira-insights-fetch';
import { useContainerContext } from '@atlassian/jira-providers-container-context';

const PACKAGE_LOCATION = 'jira.insights.common';

export const useHasPermission = (
	permissionName: string,
): {
	hasPermission: boolean;
	isLoading: boolean;
} => {
	const [hasPermission, setHasPermission] = useState<boolean>(false);
	const [isLoading, setIsLoading] = useState<boolean>(true);

	const [{ data }] = useContainerContext();
	// @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'. | TS2339 - Property 'project' does not exist on type 'ContainerContext'.
	const projectContext = data && data.project ? data.project : null;
	const projectId = (projectContext && projectContext.id) || 0;
	const isSimplified = projectContext != null && projectContext.isSimplified;

	const fetchData = useCallback(async () => {
		if (isSimplified) {
			setHasPermission(true);
			setIsLoading(false);
			return;
		}

		try {
			const response = await fetchJson(
				`/rest/api/2/mypermissions?permissions=${permissionName}&projectId=${projectId}`,
			);

			const permission: boolean =
				response && response.permissions && response.permissions[permissionName]
					? response.permissions[permissionName].havePermission
					: false;

			setHasPermission(permission);
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (e: any) {
			log.safeErrorWithoutCustomerData(
				PACKAGE_LOCATION,
				`Failed to fetch permission ${permissionName}`,
				e,
			);
			setHasPermission(false);
		}
		setIsLoading(false);
	}, [permissionName, projectId, isSimplified]);

	useEffect(() => {
		if (projectContext) {
			fetchData();
		} else {
			setIsLoading(false);
		}
	}, [fetchData, projectContext]);

	return { hasPermission, isLoading };
};
